<template>
  <div class="owal-elopement-alerts__container westchester">
    <div class="owal-elopement-alerts__alignment" :class="numOfAlertSources === 1 ? 'full-size' : ''">
      <owal-header-banner
        :title="alertCountMessage"
        :show-secondary-button="false"
        class="alerts-header"
        :class="{left: visibleAlerts.length > 0}"
        dot-color="#52ff52"
      />
      <elopement-alert-dismiss-modal
        v-if="alertToDismissUUID && shouldDismissWithPIN"
        :use-pin="shouldDismissWithPIN"
        :alert-id="alertToDismissUUID"
        @did-dismiss="handleDismissal"
        @cancel="clearPinDismiss"
      />
      <mask-alert-banner
        v-for="alert in visibleAlerts"
        :key="alert.alertId"
        v-bind="alert"
        :now="now"
        @click="handleClick"
      />
    </div>
  </div>
</template>

<script>
import MaskAlertBanner from './MaskAlertBanner'
import ElopementAlertDismissModal from './ElopementAlertDismissModal'
import {AutoSizingList} from '@/mixins'
import {OwalHeaderBanner} from '@/libraries/owal-ui'
import {mapActions, mapGetters} from 'vuex'
import {Operation, Service} from '@/libraries/permissions'
import {dismissAlertWithPin} from '@/libraries/api/facesAlerts'
import {DomainPreferences} from "@/libraries/permissions/domainPreferences";

export default {
  name: 'MaskAlerts',
  components: {
    MaskAlertBanner,
    ElopementAlertDismissModal,
    OwalHeaderBanner,
  },
  mixins: [AutoSizingList],
  data () {
    return {
      alertToDismissUUID: undefined,
      now: undefined,
      refreshIntervalHandle: undefined,
    }
  },
  computed: {
    ...mapGetters({
      faceMaskAlerts: 'faceMaskAlerts/alerts',
      lastRefresh: 'elopementRisks/lastRefresh',
      canPerformOperationForService:
        'entitlements/canPerformOperationForService',
      currentDomain: 'currentDomain',
      preferences: 'preferences',
    }),
    numOfAlertSources () {
      let alertSources = this.preferences[DomainPreferences.ALERTS_SOURCE]
      return Array.isArray(alertSources) ? alertSources.length : 1
    },
    alertCountMessage () {
      if (this.visibleAlerts.length === 0) {
        return `No recent mask alerts at ${this.lastRefresh}`
      } else if (this.visibleAlerts.length === 1) {
        return '1 No-Mask Alert'
      }
      return `${this.visibleAlerts.length} No-Mask Alerts`
    },
    lastRefreshMessage () {
      return `Last Refreshed at ${this.lastRefresh}`
    },
    visibleAlerts () {
      return this.faceMaskAlerts
    },
    shouldDismissWithPIN () {
      return this.canPerformOperationForService(
        Service.ALERTING,
        Operation.PIN_DISMISS_ALERT,
      )
    },
  },
  methods: {
    ...mapActions({
      refreshAlerts: 'elopementRisks/checkMostRecent',
      clearAlerts: 'elopementRisks/clearAlertsData',
    }),
    ...mapGetters(['faceForUUID']),
    /** Clear alerts */
    clearPinDismiss () {
      this.alertToDismissUUID = undefined
      this.replyMessage = undefined
    },
    /** In response to a click, store the id of the alert, so it's passed to the prompt's prop. */
    handleClick (alertId) {
      const canDismiss = this.shouldDismissWithPIN
      if (canDismiss) {
        this.alertToDismissUUID = alertId
      } else {
        dismissAlertWithPin(alertId, 'me')
          .then(response => response.data)
          .then(data => {
            if (data.ok) {
              this.refreshAlerts()
            } else if (!data.ok) {
              window.alert(data.error)
            }
          })
      }
    },
    /** When alerts are dismissed, hide the modal and show the prompt. */
    handleDismissal (success) {
      // TODO: fix this for mask alerts
      this.clearPinDismiss()
      this.refreshAlerts()
    },
    loadPageData: function () {
      this.clearAlerts()
      this.refreshAlerts()
      if (this.refreshIntervalHandle) {
        clearInterval(this.refreshIntervalHandle)
      }
      this.refreshIntervalHandle = setInterval(
        function () {
          this.refreshAlerts()
        }.bind(this),
        30 * 1000,
      )
    },
  },
  mounted () {
    this.loadPageData()
    setInterval(() => {
      this.now = new Date()
    }, 5000)
  },
}
</script>

<style scoped>
  .owal-elopement-alerts__container{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 1.5rem 1.5rem 0rem 1.5rem;

  }

  .owal-elopement-alerts__alignment {
    padding-bottom: 100px;
    /*overflow-y: scroll;*/
  /*  display: flex;*/
  /*  flex: initial;*/
  /*  flex-direction: row;*/
  /*  flex-wrap: wrap;*/
  /*  width: 100%;*/
  }
  /*.owal-elopement-alerts__alignment.full-size {*/
  /*  width: 68.5714285714rem;*/
  /*}*/
  .westchester {
    padding-top: 7rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    overflow-y: auto;
  }
</style>
